<template>
    <div class="score" :class="className">
        <div class="bg" v-if="isFinish"></div>
        <div class="bgimg" v-if="!isFinish"></div>
        <p class="number">{{animatedScore}}</p>
        <p class="hint">分</p>
    </div>
</template>

<script>
    import TWEEN from 'tween'
	export default {
		props: {
			score: {
			    type: Number,
				default: 100
            },
            isFinish: {
			    type: Boolean,
			    default: false
            }
        },
		data () {
			return {
				level: 1,
				animatedScore: 100
            }
		},
        computed: {
			className () {
				let level = {};
				level['level'+this.level] = true;
				return level;
            }
        },
        created() {
            this.init(100, this.score);
        },
        watch: {
            score(newVal, oldVal) {
                this.init(oldVal, newVal);
            }
        },
        methods: {
		    init(oldVal, newVal) {
                if (newVal >= 60) {
                    this.level = 1;
                } else if (newVal < 60 && newVal >= 40) {
                    this.level = 2;
                } else if (newVal < 40 && newVal >= 0) {
                    this.level = 3;
                }
                this.animateInit(oldVal, newVal);
            },
		    animateInit(startValue, endValue) {
                let vm = this;
                function animate () {
                    if (TWEEN.update()) {
                        requestAnimationFrame(animate)
                    }
                }
                new TWEEN.Tween({ tweeningValue: startValue })
                    .easing(TWEEN.Easing.Quadratic.Out)
                    .to({ tweeningValue: endValue }, 500)
                    .onUpdate(function () {
                        vm.animatedScore = this.tweeningValue.toFixed(0)
                    })
                    .start();
                animate()
            }
        }
	}
</script>

<style lang="scss" scoped>
    $size: 8rem;
    $color: #8492A6;
    @mixin scorePostiton() {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        line-height: $size;
        font-family: '微软雅黑 Bold', '微软雅黑';
        font-weight: 700;
    }
    @mixin setColor($color, $rgba, $level: 3) {
        $img: '../../content/images/check-progress-icon'+ $level +'.png';
        .bg {
            border-color: $color;
            /*background: -webkit-gradient(linear, 0 15, 0 bottom, from(#ffffff), to($rgba));*/
        }
        .bgimg {
            background-image: url($img);
        }
        .number, .hint {
            color: $color
        }
    }
    .score {
        position: relative;
        width: $size;
        height: $size;
        box-sizing: border-box;
        &.level1 {
            @include setColor(#18d068, rgba(132,146,166, 0.3), 1);
        }
        &.level2 {
            @include setColor(#e9b20b, rgba(19,206,102, 0.3), 2);
        }
        &.level3 {
            @include setColor(#e9590b, rgba(247,186,42, 0.3), 3);
        }
        &.level4 {
            @include setColor(#FF4949, rgba(255,73,73, 0.3));
        }
    }
    @-webkit-keyframes scoreAnim {
        from {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    @keyframes scoreAnim {
        from {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    .bgimg {
        @include scorePostiton;
        background-size: 100%;
        -webkit-animation: scoreAnim 1s linear infinite;
        animation: scoreAnim 1s linear infinite;
    }
    .bg {
        @include scorePostiton;
        border: .5rem solid $color;
        border-radius: 50%;
        /*background: -webkit-gradient(linear, 0 15, 0 bottom, from(#ffffff), to(rgba(29,140,224, 0.3)));*/
        box-sizing: border-box;
    }
    .number {
        @include scorePostiton;
        z-index: 2;
        margin: 0;
        text-align: center;
        padding-right: 1rem;
        font-size: 2.8rem;
        color: $color;
        box-sizing: border-box;
    }
    .hint {
        @include scorePostiton;
        margin: 0;
        padding: 10px 15px 0 0;
        text-align: right;
        font-size: 16px;
        color: $color;
        box-sizing: border-box;
    }
</style>



// WEBPACK FOOTER //
// app/view/detail/Score.vue